import script from "./SnmpTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SnmpTab.vue?vue&type=script&setup=true&lang=js"

import "./SnmpTab.vue?vue&type=style&index=0&id=22d9adde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d9adde"]])

export default __exports__